export const commaDelimitNumber = x =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);
